import React from 'react';
import { Route } from 'react-router-dom';
import { Container } from 'reactstrap';
import StoreNav from './Pages/EndUser/Store/StoreNav/StoreNav';
import NavMenu from './NavComponents/NavMenu/NavMenu';
import NavFooter from './NavComponents/NavFooter/NavFooter';
import './Pages/EndUser/Store/Store.scss';

const Layout = ({ children, ...rest }) => {
    return (
        <div>
            <NavMenu />
            <StoreNav />
            <Container fluid={true} className="StoreLayoutContainer">
                {children}
            </Container>
            <NavFooter />
        </div>
    )
}

const StoreLayout = ({ component: Component, ...rest }) => {

    return (
        <Route {...rest} render={matchProps => (
            <Layout>
                <Component {...matchProps} />
            </Layout>
        )} />
    )
};

export default StoreLayout;
